import React from 'react';
import Select from '../../../../../components/shared/Select/Select';

interface CurrencySelectorProps {
  value?: string;
  onChange?: (value: string) => void;
  id?: string;
}

const currencyOptions = [
  { value: 'usd', label: 'USD ($)' },
  { value: 'eur', label: 'EUR (€)' },
  { value: 'gbp', label: 'GBP (£)' },
  { value: 'jpy', label: 'JPY (¥)' },
  { value: 'cad', label: 'CAD ($)' },
  { value: 'aud', label: 'AUD ($)' },
];

const CurrencySelector: React.FC<CurrencySelectorProps> = ({ value, onChange, id = 'currency' }) => {
  return (
    <Select
      label="Currency"
      id={id}
      value={value}
      options={currencyOptions}
      onChange={onChange}
      className="setting-select"
    />
  );
};

export default CurrencySelector;
